import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const BOOKING_URL = 'https://cryobybreum.planway.com/';

export default function NotFound() {
  return (
    <div className="py-24 sm:py-32 flex items-center justify-center">
      <SEO preset="notFound" />
      <div className="max-w-xl mx-auto px-4 text-center space-y-6">
        <span className="font-sans text-6xl sm:text-7xl font-bold text-espresso/30 block tracking-widest">
          404
        </span>

        <h1 className="font-sans text-2xl sm:text-3xl lg:text-4xl font-semibold text-espresso uppercase tracking-wider">
          Siden blev ikke fundet
        </h1>

        <p className="text-taupe text-base sm:text-lg leading-relaxed">
          Beklager, den side du leder efter findes ikke eller er blevet flyttet. Du kan altid vende tilbage til forsiden eller udforske vores behandlinger.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-accent-brown text-white text-xs font-semibold tracking-widest uppercase hover:bg-accent-brown-hover transition-colors shadow-xs"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>

          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-sand hover:bg-sand-dark text-espresso text-xs font-semibold tracking-widest uppercase border border-taupe-border/80 transition-colors"
          >
            <span>Book tid på Planway</span>
            <i className="fa-solid fa-arrow-up-right-from-square text-xs" aria-hidden="true" />
          </a>
        </div>
      </div>
    </div>
  );
}
